<template>
  <span>
    <v-row dense>
      <v-col cols="6" v-for="chart in chartDataComputed" :key="chart.chartRef">
        <v-card-charts-dashboard
          :title="chart.title"
          :options="chart.options"
          :chart-ref="chart.chartRef"
          :deep-copy-on-update="chart.deepCopyOnUpdate"
          :is-loading="chart.loading"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  name: "DashboardServicosVisaoAneelCardsKpisPorCompetencia",
  components: {
    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    dados: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    metasKpis: {
      type: Object,
      required: true,
    },
    exportingOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    chartPendentesSuspensosOptions: {},
    chartPsaOptions: {},
    chartSolicitadosOptions: {},
    chartSuspensosOptions: {},
    chartData: [
      {
        title: "Serviços Pendentes + Serviços Suspensos",
        chartRef: "pendentes-suspensos",
        optionsProp: "chartPendentesSuspensosOptions",
        deepCopyOnUpdate: false,
      },
      {
        title: "PSA - Percentual de Serviços em Atraso",
        chartRef: "psa",
        optionsProp: "chartPsaOptions",
        deepCopyOnUpdate: false,
      },
      {
        title: "Serviços Solicitados",
        chartRef: "solicitados",
        optionsProp: "chartSolicitadosOptions",
        deepCopyOnUpdate: false,
      },
      {
        title: "Serviços Suspensos",
        chartRef: "suspensos",
        optionsProp: "chartSuspensosOptions",
        deepCopyOnUpdate: false,
      },
    ],
  }),
  computed: {
    chartDataComputed() {
      return this.chartData.map((chart) => {
        return {
          ...chart,
          options: this[chart.optionsProp],
          loading: this.loading,
        };
      });
    },
  },
  mounted() {
    this.setChartsOptions();
  },
  methods: {
    setChartsOptions() {
      this.setChartPendentesSuspensosOptions();
      this.setChartPsaOptions();
      this.setChartSolicitadosOptions();
      this.setChartSuspensosOptions();
    },
    getColumnChartDefaultOptions() {
      return {
        chart: {
          type: "column",
          zoomType: "x",
          height: 300,
          animation: false,
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: true },
        xAxis: {
          categories: this.categories,
          crosshair: true,
          title: {
            text: "Competência",
          },
        },
        yAxis: {
          title: { text: null },
        },
        plotOptions: {
          series: {
            animation: false,
          },
          column: {
            stacking: "normal",
          },
        },
        tooltip: {
          shared: true,
        },
        lang: {
          noData: "Sem dados para exibição",
        },
        series: [],
        exporting: this.exportingOptions,
      };
    },
    setChartPendentesSuspensosOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "Suspensos",
          animation: false,
          data: this.categories.map((category) => {
            return category in this.dados?.suspensos ?? {}
              ? {
                  x: this.categories.indexOf(category),
                  y: Number(this.dados.suspensos[category]),
                }
              : { x: this.categories.indexOf(category), y: null };
          }),
          // .filter(val => val !== null && val.y !== null && val.y > 0)
        },
        {
          name: "Pendentes",
          animation: false,
          data: this.categories.map((category) => {
            return category in this.dados?.pendentes ?? {}
              ? {
                  x: this.categories.indexOf(category),
                  y: Number(this.dados.pendentes[category]),
                }
              : { x: this.categories.indexOf(category), y: null };
          }),
          // .filter(val => val !== null && val.y !== null && val.y > 0)
        },
      ];

      this.chartPendentesSuspensosOptions = options;
    },
    setChartPsaOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "PSA",
          animation: false,
          data: this.categories.map((category) => {
            return category in this.dados?.psa ?? {}
              ? {
                  x: this.categories.indexOf(category),
                  y: Number(this.dados.psa[category]),
                }
              : { x: this.categories.indexOf(category), y: null };
          }),
          // .filter(val => val !== null && val.y !== null && val.y > 0)
        },
        {
          name: "Meta",
          animation: false,
          stickyTracking: false,
          type: "spline",
          data: this.categories
            .map((category) => {
              return category in this.metasKpis
                ? {
                    x: this.categories.indexOf(category),
                    y: Number(this.metasKpis?.[category]?.psa),
                  }
                : { x: this.categories.indexOf(category), y: null };
            })
            .filter((val) => val !== null && val.y !== null),
        },
      ];

      this.chartPsaOptions = options;
    },
    setChartSolicitadosOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "Solicitados",
          animation: false,
          data: this.categories.map((category) => {
            return category in this.dados?.solicitados ?? {}
              ? {
                  x: this.categories.indexOf(category),
                  y: Number(this.dados.solicitados[category]),
                }
              : { x: this.categories.indexOf(category), y: null };
          }),
          // .filter(val => val !== null && val.y !== null && val.y > 0)
        },
        {
          name: "Meta",
          animation: false,
          stickyTracking: false,
          type: "spline",
          data: this.categories
            .map((category) => {
              return category in this.metasKpis
                ? {
                    x: this.categories.indexOf(category),
                    y: Number(this.metasKpis?.[category]?.solicitacoes),
                  }
                : { x: this.categories.indexOf(category), y: null };
            })
            .filter((val) => val !== null && val.y !== null),
        },
      ];

      this.chartSolicitadosOptions = options;
    },
    setChartSuspensosOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "Suspensos",
          animation: false,
          data: this.categories.map((category) => {
            return category in this.dados?.suspensos ?? {}
              ? {
                  x: this.categories.indexOf(category),
                  y: Number(this.dados?.suspensos[category]),
                }
              : { x: this.categories.indexOf(category), y: null };
          }),
          // .filter(val => val !== null && val.y !== null && val.y > 0)
        },
        {
          name: "Meta",
          animation: false,
          stickyTracking: false,
          type: "spline",
          data: this.categories
            .map((category) => {
              return category in this.metasKpis
                ? {
                    x: this.categories.indexOf(category),
                    y: Number(this.metasKpis?.[category]?.suspensos),
                  }
                : { x: this.categories.indexOf(category), y: null };
            })
            .filter((val) => val !== null && val.y !== null),
        },
      ];

      this.chartSuspensosOptions = options;
    },
  },
  watch: {
    dados() {
      this.setChartsOptions();
    },
  },
};
</script>

<style></style>
